import { render, staticRenderFns } from "./SpOrderStatusFilter.vue?vue&type=template&id=67f99f5e"
import script from "./SpOrderStatusFilter.vue?vue&type=script&lang=js"
export * from "./SpOrderStatusFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports